<template>
  <section class="reports">
    <article class="article">
      <h1 class="article-title">数据报告—为企业提供专业的个性化方案定制信息服务</h1>
      <section class="article-inner">
        <section class="article-left">
          <template v-for="(item, index) in reportsList">
            <div class="article-item" :key="index">
              <router-link to="/login">
                <div class="article-item-cover">{{item.title}}</div>
                <h2 class="article-item-title">{{item.title}}</h2>
                <p class="article-item-desc">{{item.desc}}</p>
              </router-link>
            </div>
          </template>
        </section>
        <aside class="article-right">
          <h4>热门报告</h4>
          <ul>
            <router-link 
              v-for="(item, idx) in hotTopic" 
              :key="idx"
              :to="item.path" >
              <li><span>{{idx+1}}</span>{{item.title}}</li>
            </router-link>
          </ul>
        </aside>
      </section>
    </article>
  </section>
</template>

<script>
import zmBanner  from '@/components/Banner.vue'
export default {
  components: {
    zmBanner
  },
  data () {
    return {
      reportsList: [{
        title: '2019上半年微信小程序市场研究报告',
        desc: '《2019上半年微信小程序市场研究报告》通过对小程序的概念解析和功能分析，对目前的行业发展趋势进行总结，对表现突出的小程序进行画像分析。旨在得出微信小程序发展的一些规律和特点，协助企业了解行业发展状况......'
      }, {
        title: '2019年Q2中国互联网流量季度分析报告',
        desc: '《2019年Q2中国互联网流量季度分析报告》首先从市场发展概览、行业发展情况角度梳理2019年Q2中国PC互联网发展概况；其次从市场发展概览、移动渠道市场、新势力市场的发展、热门行业分析以及......'
      }, {
        title: '2019年中国在线旅游平台用户洞察研究报告',
        desc: '《2019年中国在线旅游平台用户洞察研究报告》是利用定量研究方法，对在线旅游平台用户的出游行为、预订习惯、消费行为等方面进行在线调查及研究，从而帮助了解整体旅游用户群体特征及人群画像，分析.......'
      }, {
        title: '2019年中国游戏直播行业研究报告',
        desc: '2019年游戏直播行业发展进入成熟期，平台间的竞争与离场给市场带来新活力；头部平台收入的迅速增长有效带动整体游戏直播市场规模增长；行业更加规范，整体行业向着良性竞争方向发展。而为拓展更大的市场......'
      }, {
        title: '2019年中国企业级SaaS行业研究报告',
        desc: '2015年中国企业级SaaS浪潮兴起，但时至今日市场并未迎来预期中的爆发。本报告以此为出发点，探讨出现SaaS预期偏差的原因，在得出SaaS并非伪命题的基础上，给出对中国企业级SaaS的合理预期——软件SaaS化大势所趋......'
      }, {
        title: '中国泛游学与营地教育行业白皮书-发布版',
        desc: '《2019泛游学与营地教育白皮书》从行业学术研究角度与行业实践角度，第一次提出泛游学与营地教育的概念。《白皮书》希望对行业发展历史、中国行业现状、中国宏观经济政策、泛游学产品消费者需求等进行多方面的思考，真诚......'
      }],
      hotTopic: [{
        title: '2019上半年微信小程序市场研究报告',
        path: '/login'
      }, {
        title: '2019年Q2中国互联网流量季度分析报告',
        path: '/login'
      }, {
        title: '2019年中国游戏直播行业研究报告',
        path: '/login'
      }]
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.article {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0; 
}
.article-title {
  font-size: 24px;
  text-align: center;
}
.article-inner {
  padding: 65px 88px;
  overflow: auto;
}
.article-left {
  float: left;
  margin: 0 14px 44px 0;
  background-color: #fff;
  box-shadow: 0 0 5px 3px rgba(0, 0, 0, .05)
}
.article-item {
  width: 680px;
  overflow: hidden;
  padding: 20px;
  border-bottom: 1px solid #ececec;
}
.article-item:last-child {
  border: none;
}
.article-item-cover {
  float: left;
  width: 244px;
  height: 170px;
  padding: 60px 12px;
  margin-right: 20px;
  color: #fff;
  background-image: url('../assets/cardBg.png');
  font-size: 18px;
  text-align: center;
}
.article-item-title {
  color: #222;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 24px;
  margin-bottom: 10px;
  font-weight: 500;
}
.article-item-desc {
  overflow: hidden;
  color: #333;
  font-size: 14px;
  line-height: 26px;
}
.article-right {
  width: 330px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 0 5px 3px rgba(0, 0, 0, .05);
  padding: 12px;
}
.article-right > h4 {
  color: #222;
  line-height: 24px;
  margin-bottom: 16px;
  font-weight: 500
}
.article-right li {
  font-size: 16px;
  color: #222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 10px;
}
.article-right li span {
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  background-color: #34a2f6;
  margin-right: 10px;
  font-weight: 700;
}
.article-right li:hover {
  text-decoration: underline;
}
.article-item-remark {
  color: #444;
  font-size: 12px;
  margin-top: 10px;
  overflow: hidden;
}
</style>